import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppLayoutModule } from './layout/app.layout.module';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { AngularFireDatabaseModule } from '@angular/fire/compat/database';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { RouteReuseStrategy, RouterModule } from '@angular/router';
import { AppSidebarMenuService } from './layout/app.menu.service';
import { environment } from '../environments/environment';
import { ChipModule } from 'primeng/chip';

@NgModule({
    declarations: [
        AppComponent,
    ],
    imports: [
        AppRoutingModule,
        AppLayoutModule,
        AngularFireAuthModule,
        AngularFireModule.initializeApp(environment.database),
        AngularFireDatabaseModule,
        AngularFirestoreModule,
        ProgressSpinnerModule,
        IonicModule.forRoot({ mode: "md" }),
        RouterModule,
        ChipModule,
    ],
    providers: [
        // { provide: LocationStrategy, useClass: HashLocationStrategy }
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        AppSidebarMenuService
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
